import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import { FaArrowLeft, FaEye, FaEyeSlash } from 'react-icons/fa';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [showVideo, setShowVideo] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState('');


  const API = process.env.REACT_APP_API_URL || "https://api.moulirobots.com";

  // const API = process.env.REACT_APP_API_URL || "http://127.0.0.1:1500";

  const isWeakPassword = (pwd) =>
    pwd.length < 6 || !/[a-zA-Z]/.test(pwd) || !/\d/.test(pwd);

  const validatePassword = () => {
    if (!password) {
      setPasswordError('Password is required.');
      return false;
    }
    if (isWeakPassword(password)) {
      setPasswordError(
        'please enter a valid password'
      );
      return false;
    }
    setPasswordError('');
    return true;
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      const blocked = 
        (e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].includes(e.key.toUpperCase())) ||
        (e.ctrlKey && e.key.toUpperCase() === 'U') ||
        (e.key === 'F12');

      if (blocked) {
        e.preventDefault();
        e.stopPropagation();
        alert('Blocked developer tools shortcut');
      }
    };

    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    const disableSelection = (e) => {
      e.preventDefault();
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('selectstart', disableSelection);
    document.addEventListener('dragstart', disableSelection);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('selectstart', disableSelection);
      document.removeEventListener('dragstart', disableSelection);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validatePassword()) return;

    const data = { username, password };

    try {
      const response = await fetch(`${API}/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (response.ok) {
        setMessage(result.message);
        localStorage.setItem('username', username);
        navigate(`/chat/${username}`, { state: { username } });
        setError('');
      } else {
        setError(result.error);
        setMessage('');
      }
    } catch (error) {
      setError('An error occurred. Please try again later.');
      setMessage('');
    }
  };

  const handleToggle = () => {
    setShowVideo((prev) => !prev); 
  };

  return (
    <div className='login_home'>
      <div className="card">
        <div className="card2">
          <form className="form" onSubmit={handleSubmit}>
            <p id="heading">Login</p>
            <div className="field">
              <svg viewBox="0 0 16 16" fill="currentColor" height={16} width={16} xmlns="http://www.w3.org/2000/svg" className="input-icon">
                <path d="M13.106 7.222c0-2.967-2.249-5.032-5.482-5.032-3.35 0-5.646 2.318-5.646 5.702 0 3.493 2.235 5.708 5.762 5.708.862 0 1.689-.123 2.304-.335v-.862c-.43.199-1.354.328-2.29.328-2.926 0-4.813-1.88-4.813-4.798 0-2.844 1.921-4.881 4.594-4.881 2.735 0 4.608 1.688 4.608 4.156 0 1.682-.554 2.769-1.416 2.769-.492 0-.772-.28-.772-.76V5.206H8.923v.834h-.11c-.266-.595-.881-.964-1.6-.964-1.4 0-2.378 1.162-2.378 2.823 0 1.737.957 2.906 2.379 2.906.8 0 1.415-.39 1.709-1.087h.11c.081.67.703 1.148 1.503 1.148 1.572 0 2.57-1.415 2.57-3.643zm-7.177.704c0-1.197.54-1.907 1.456-1.907.93 0 1.524.738 1.524 1.907S8.308 9.84 7.371 9.84c-.895 0-1.442-.725-1.442-1.914z" />
              </svg>
              <input 
                type="text" 
                className="input-field"
                placeholder="Username" 
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>

            <div className="field">
              <svg viewBox="0 0 16 16" fill="currentColor" height={16} width={16} xmlns="http://www.w3.org/2000/svg" className="input-icon">
                <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" />
              </svg>
              <input 
                type={showPassword ? "text" : "password"}
                className="input-field" 
                placeholder="Password" 
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onBlur={validatePassword}
                required
              />
              <span
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            {passwordError && <p className="error-text">{passwordError}</p>}
            {error && <p className="error-text">{error}</p>}
            {message && <p className="success-text">{message}</p>}

            <div className="btn">
              <button className="button1" type="submit">
                Login
              </button>
              <button type="button" onClick={() => navigate('/sign-up')} className="button2">
                Sign Up
              </button>
            </div>

            <button type="button" className="button3" onClick={() => navigate('/forgot')}>
              Forgot Password
            </button>
          </form>
        </div>
      </div>
      <button onClick={() => navigate('/')} className='back_button'>
        <FaArrowLeft />
      </button>
    </div>
  );
};

export default Login;